import React, {FC, useEffect, useState} from 'react'
import { useForm } from '../../../../../../hooks/useForm';
import { Message } from "../../../../../../utils";
import { DepartmentHeadRecommendationApi } from "../../../../../../api";
import { useTranslation } from "react-i18next";
import DrawerForm from "../../../../../../components/Drawer/DrawerForm";
import DepartmentHeadRecommendationAddOrEditForm from "./DepartmentHeadRecommendationForm.form";
import {useErrorHandler} from "@/hooks/useErrorHandler";

const initialState  = {
    modalTitle: 'Create Example',
    itemData: {},
    fields: {
        remark: null,
        action_status: null,
    },
    isNewRecord: true,
    loading: false,
}

const DepartmentHeadRecommendationFormController: FC<any> = props => {
    const { t } = useTranslation();
    const { entityId, reloadForm, isShowForm, handleCallbackFunc } = props
    const { formRef, initialValues, isSubmitting, setIsSubmitting, handleChange, handleSubmitFailed, resetForm, setErrors } = useForm(initialState.fields);
    const { handleErrorMessage, handleSuccessMessage, showErrorMessage } = useErrorHandler();

    const [modalTitle, setModalTitle] = useState(initialState.modalTitle);
    const [itemData, setItemData] = useState(initialState.itemData);
    const [isNewRecord, setIsNewRecord] = useState(initialState.isNewRecord);
    const [loading, setLoading] = useState(initialState.loading);

    useEffect(() => {
        if (entityId && isShowForm) {
            setIsNewRecord(false);
            setModalTitle('Update Request');
            resetForm();
            loadData();
        }
        else {
            resetForm();
            setModalTitle(initialState.modalTitle);
            setIsNewRecord(initialState.isNewRecord);
        }
    }, [entityId, reloadForm])

    const loadData = (): Promise<any> => {
        return new Promise((resolve, reject) => {
            setLoading(true);
            DepartmentHeadRecommendationApi.getById(entityId)
                .then(res => {
                    setItemData(res.data.data);
                    const initFormDta ={
                        remark: res.data.data.remark,
                        action_status: res.data.data.action_status,
                    }
                    handleChange(initFormDta)
                    formRef.setFieldsValue(initFormDta)
                    setLoading(false);
                    resolve(res.data.data);
                })
                .catch(err => {
                    handleErrorMessage(err);
                    setLoading(false);
                    reject(err);
                });
        });
    }

    const handleSubmit = (values: any): void => {
        if (entityId) {
            handleUpdate(values);
        }
    }

    const handleUpdate = (values: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            setLoading(true);
            setIsSubmitting(true);
            const payload = {
                remark: values.remark,
                action_status: values.action_status,
            }
            DepartmentHeadRecommendationApi.update(entityId, payload)
                .then(res => {
                    handleSuccessMessage(res);
                    handleCallbackFunc(null, 'hideForm');
                    handleCallbackFunc(null, 'updateListItem', entityId, res.data.data);
                    handleCallbackFunc(null, 'reloadView');
                    setLoading(false);
                    setIsSubmitting(false);
                    resolve(res);
                })
                .catch(err => {
                    handleErrorMessage(err);
                    setLoading(false);
                    setIsSubmitting(false);
                    reject(err);
                });
        });
    }

    return (
        <div className="form-page-container form-page-container-example">
            <DrawerForm
                loading={loading}
                isNewRecord={isNewRecord}
                itemData={itemData}
                modalTitle={modalTitle}
                isSubmitting={isSubmitting}
                isShowForm={isShowForm}
                formRef={formRef}
                initialValues={initialValues}
                component={DepartmentHeadRecommendationAddOrEditForm}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                handleSubmitFailed={handleSubmitFailed}
                handleCallbackFunc={handleCallbackFunc}
            />
        </div>
    );
}

export default React.memo(DepartmentHeadRecommendationFormController);
